"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.PLACEMENT_TYPE_SEARCH = exports.PLACEMENT_TYPE_PROFILE = exports.BOOK_TRACKING_PARAM_NAME = void 0;
const PLACEMENT_TYPE_PROFILE = exports.PLACEMENT_TYPE_PROFILE = 'profile';
const PLACEMENT_TYPE_SEARCH = exports.PLACEMENT_TYPE_SEARCH = 'search';

// param used to track booking source in DBW
const BOOK_TRACKING_PARAM_NAME = exports.BOOK_TRACKING_PARAM_NAME = 'book_src';